import { useCallback } from "react";

import { EventButtonTypes, EventInputTypes, EventScreenTypes } from "@/constants/event";
import { useGender } from "@/utils/GenderProvider";

const MAN_PREFIX = "man";
const FEMALE_PREFIX = "female";
const AGE_ADAPTATION_PREFIX = "age";

export const usePrefix = () => {
    const { isFemale, isAgeFlow } = useGender();

    const getEventType = useCallback(
        (type: EventScreenTypes | EventInputTypes | EventButtonTypes | string) => {
            if (isAgeFlow) {
                return `${AGE_ADAPTATION_PREFIX}_${type}`;
            }
            return `${isFemale ? FEMALE_PREFIX : MAN_PREFIX}_${type}`;
        },
        [isFemale, isAgeFlow]
    );

    return { getEventType };
};
